"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnScrollCenter = void 0;
function useOnScrollCenter(totalRows) {
    return function (event, onScrollCenter) {
        var scrollForward = event.scrollForward, visibleStartIndex = event.visibleStartIndex;
        // If the user scrolls to the middle of the table
        if (visibleStartIndex >= Math.round(totalRows / 2) - 1 && scrollForward) {
            onScrollCenter();
        }
    };
}
exports.useOnScrollCenter = useOnScrollCenter;
